// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.devnagri_container {
  width: 9rem;
  max-height: 800px;
  margin-bottom: 10px;
  /* position: fixed;
    bottom: 70px;
    right: 18px; */
  padding: 1px;
  display: none;
  z-index: 99999999999999;
  border-radius: 6px;
  display: flex, none;
  justify-content: center;
}
.devnagri_outermostdivclass {
  max-width: fit-content;
}
.devnagri_container > ul {
  background-color: white;
  border: 1px solid #e3e3e3;
  border-radius: 6px;
  padding: 6px;
  width: 100%;
  max-height: 800px;
  margin-bottom: 0;
}
.devnagri_container > ul > li {
  padding: 0;
  display: flex;
  justify-content: center;
  line-height: 35px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Verdana', sans-serif;
}
.devnagri_container > ul > li:hover {
  background: var(--hover-bg-color);
}
.devnagri_open_button {
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  margin-bottom: 10px;
  position: relative;
  outline: none;
  /* bottom: 23px; */
  /* right: 18px; */
  height: 40px;
  max-width: 393px;
  z-index: 9999999999999;
  /* background-color: #ffffff; */
  background-color: var(--button-bg-color);
}
.devnagri_owner_button {
  outline: none;
  cursor: pointer;
  height: 27px;
  width: 27px;
  margin: 5px;
  margin-left: 7px;
  /* background-image: url(https://i.ibb.co/7vDdcRk/Edit-01.png); */
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
}
.devnagri_owner_cancel_button {
  border: 0;
  outline: none;
  cursor: pointer;
  height: 27px;
  width: 27px;
  margin: 5px 0;
  margin-left: 5px;
  margin-right: 4px;
  z-index: 99999999999999;
  /* background-image: url(https://i.ibb.co/wQfhYSN/Cross-01.png); */
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
}
.devnagri_owner_send_button {
  outline: none;
  cursor: pointer;
  height: 27px;
  width: 27px;
  margin: 5px 0;
  margin-left: 4px;
  margin-right: 5px;
  z-index: 99999999999999;
  /* background-image: url(https://i.ibb.co/M5YHpVz/Save-01.png); */
  background-repeat: no-repeat;
  background-size: cover;
}
.devnagri_border {
  border: 2px solid #ff0404;
}
.Devnagri-ring {
  display: inline-block;
  width: 40px;
  height: 40px;
}
/* .button {
  background-color: white;
} */
.Devnagri-ring:after {
  content: ' ';
  display: block;
  /* position: fixed; */
  /* bottom: 65px; */
  /* right: 165px; */
  height: 40px;
  width: 40px;
  color: #082dfc;
  z-index: 99999999999999;
  border-radius: 50%;
  border: 2px solid #082dfc;
  border-color: #082dfc transparent #082dfc transparent;
  animation: Devnagri-ring 1.5s linear infinite;
}
@keyframes Devnagri-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.devnagri_dynamic_container {
  position: fixed;
  bottom: 15px;
  right: 50px;
  left: 50px;
  top: 15px;
  width: 600px;
  max-height: 390px;
  background-color: #ffffff;
  border: 2px solid #adacac;
  border-radius: 5px;
  flex-wrap: wrap;
  margin: 10px auto;
  padding: 0 15px;
  overflow-y: scroll;
  z-index: 99999999999999999999999999999999;
}
.devnagri_div_lable_input {
  padding: 0 5px;
  display: inline-block;
}
.devnagri_label {
  font-weight: 600;
  line-height: 2;
  font-size: larger;
}
.devnagri_h1_eng {
  padding-left: 5px;
  display: inline-block;
  line-height: 1;
  font-weight: 600;
  font-size: larger;
}
.devnagri_h1_def_lang {
  display: inline-block;
  line-height: 2;
  font-size: large;
}
.devnagri_seo_submit {
  margin-left: 225px;
  margin-top: 3px;
  outline: none;
  cursor: pointer;
  border: 0;
  float: left;
  height: 30px;
  width: 30px;
  z-index: 99999999999999;
  background-image: url(https://i.ibb.co/M5YHpVz/Save-01.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.devnagri_seo_cancel {
  margin-left: 10px;
  margin-top: 3px;
  float: left;
  cursor: pointer;
  outline: none;
  border: 0;
  height: 30px;
  width: 30px;
  z-index: 99999999999999;
  background-image: url(https://i.ibb.co/wQfhYSN/Cross-01.png);
  background-repeat: no-repeat;
  background-size: cover;
}
.devnagri_form-control {
  padding: 1px;
  font-family: Arial;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid #cccccc;
  display: block;
}
.devnagri_seo_cancel:hover {
  opacity: 0.8;
}
.devnagri_seo_submit:hover {
  opacity: 0.8;
}
.devnagri_divForArrow {
  padding-top: 15px;
  margin-left: 15px;
  margin-right: 20px;
  display: inline-block;
  height: 33px;
  width: 49px;
  background-image: url(https://www.svgrepo.com/show/24357/right-arrow.svg);
  background-repeat: no-repeat;
  background-size: cover;
  line-height: 1;
}
.devnagri_seo {
  outline: none;
  cursor: pointer;
  height: 27px;
  width: 27px;
  margin-top: 5px;
  margin-right: 5px;
  margin-left: 7px;
  /* background-image: url(https://i.ibb.co/m418FWD/SEO-01.png); */
  background-repeat: no-repeat;
  background-size: cover;
}
.devnagri_seo:hover {
  opacity: 0.9;
}
.devnagri_logo {
  outline: none;
  cursor: pointer;
  width: 30px;
  height: 30px;
  margin: 5px 0;
  margin-left: 5px;
  margin-right: 7px;
  /* background-image: url(https://i.ibb.co/GF54nQh/Devnagri-Logo-01.png); */
  background-repeat: no-repeat;
  background-size: cover;
  padding: 0px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.devnagri_logo svg {
  background: transparent !important;
  width: 24px;
}
.devnagri_written_lang {
  font-family: 'Verdana', sans-serif;
  line-height: 40px;
  cursor: pointer;
  font-size: 14px;
  margin: 0 !important;
  color: white;
}
.devnagri_upArrow {
  cursor: pointer;
  margin: 12px 7px;
  width: 16px;
  height: 16px;
  /* background-image: url(https://i.ibb.co/4tXB2Xw/up-arrow.png); */
  background-repeat: no-repeat;
  /* background-color: #ffffff; */
  background-size: cover;
  display: flex;
}
.devnagri_upArrow svg {
  background-color: transparent !important;
}
.devnagri_upArrow svg rect {
  fill: #fff !important;
}
.devnagri_upArrow svg path {
  fill: #fff !important;
}
.Devnagri-tooltip-toggle {
  position: relative;
}
.Devnagri-tooltip-toggle:before {
  content: attr(data-tooltip);
  /* here's the magic */
  position: absolute;
  /* vertically center */
  top: 50%;
  transform: translateY(-50%);
  /* move to right */
  left: 100%;
  margin-left: 0px;
  /* and add a small left margin */
  /* basic styles */
  width: 50px;
  padding: 2px;
  margin: 0px;
  border-radius: 3px;
  text-align: center;
  display: none;
  /* hide by default */
  font-size: 10px;
  font-weight: 500;
  font-family: 'Verdana', sans-serif;
  background-color: #3184c0;
  color: #fff;
}
.Devnagri-tooltip-toggle:hover:before {
  display: block;
}
.Devnagri-tooltip-toggle:before {
  top: initial;
  right: initial;
  left: initial;
  margin: initial;
  /* set new values */
  bottom: 78%;
  transform: translate(-23%, -50%);
}
.Devnagri-tooltip-toggle:after {
  content: '';
  position: absolute;
  /* position tooltip correctly */
  bottom: 105%;
  /* vertically center */
  left: 50%;
  transform: translateX(-47%);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid #3184c0;
  display: none;
}
.Devnagri-tooltip-toggle:hover:before,
.Devnagri-tooltip-toggle:hover:after {
  display: block;
}
/* new for devngari logo */
.Devnagri-tooltip-toggle-pencil {
  /* position: relative; */
}
.Devnagri-tooltip-toggle-pencil:before {
  content: attr(data-tooltip);
  /* here's the magic */
  position: absolute;
  /* vertically center */
  top: 50%;
  transform: translateY(-50%);
  /* move to right */
  left: 100%;
  margin-left: 0px;
  /* and add a small left margin */
  /* basic styles */
  width: 120px;
  padding: 4px;
  margin: 0px;
  border-radius: 3px;
  text-align: center;
  display: none;
  /* hide by default */
  font-size: 10px;
  font-weight: 500;
  font-family: 'Verdana', sans-serif;
  background-color: #3184c0;
  color: #fff;
}
.Devnagri-tooltip-toggle-pencil:hover:before {
  display: block;
}
.Devnagri-tooltip-toggle-pencil:before {
  top: initial;
  right: initial;
  left: 0px;
  margin: initial;
  bottom: 94%;
  transform: translate(0%, -69%);
  border: none;
}
.Devnagri-tooltip-toggle-pencil:after {
  content: '';
  position: absolute;
  /* position tooltip correctly */
  bottom: 101%;
  /* vertically center */
  left: 17%;
  transform: translate(-44%, -61%);
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #3184c0;
  display: none;
}
.Devnagri-tooltip-toggle-pencil:hover:before,
.Devnagri-tooltip-toggle-pencil:hover:after {
  display: block;
}
.devnagri_vl {
  border-left: 1px solid #a0a0a0;
  height: 27px;
  margin-right: 6px;
  margin-top: 5px;
  margin-left: 5px;
}
.devnagri_uiErrorEditor {
  border-radius: 5px;
  /* position: fixed; */
  outline: none;
  /* bottom: 0px; */
  /* right: 18px; */
  height: 24px;
  padding: 0px 12px;
  max-width: 300px;
  z-index: 9999999999999999999;
  background-color: blanchedalmond;
  color: red;
  font-size: 12px;
}
.devnagri_unsavedChanges {
  border-radius: 5px;
  /* position: fixed; */
  outline: none;
  /* bottom: 0px; */
  /* right: 18px; */
  height: 24px;
  padding: 0px 12px;
  width: 190px;
  z-index: 9999999999999;
  background-color: #dcda0d;
  font-size: 12px;
}
.devnagri_savedChanges {
  border-radius: 5px;
  /* position: fixed; */
  outline: none;
  /* bottom: 0px; */
  /* right: 18px; */
  height: 25px;
  padding: 0px 4px;
  max-width: 110px;
  color: #fdfafa;
  z-index: 99999999999;
  background-color: #08eebc;
  font-size: 12px;
}
#devnagri_subdomain {
  text-decoration: none;
  color: black;
}
main header {
  top: 0px;
}
/*# sourceMappingURL=main.css.map */`, "",{"version":3,"sources":["webpack://./main.css","webpack://./sdk/less/main.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,mBAAA;ECCA;;kBAEgB;EDChB,YAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;ACCF;ADEA;EACE,sBAAA;ACAF;ADGA;EACE,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;ACDF;ADGA;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kCAAA;ACDF;ADIA;EACE,iCAAA;ACFF;ADKA;EACE,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;ECHA,kBAAkB;EAClB,iBAAiB;EDKjB,YAAA;EACA,gBAAA;EACA,sBAAA;ECHA,+BAA+B;EDK/B,wCAAA;ACHF;ADMA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;ECJA,iEAAiE;EDMjE,4BAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;ACJF;ADMA;EACE,SAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;ECJA,kEAAkE;EDMlE,4BAAA;EACA,sBAAA;EACA,aAAA;ACJF;ADMA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;ECJA,iEAAiE;EDMjE,4BAAA;EACA,sBAAA;ACJF;ADOA;EACE,yBAAA;ACLF;ADOA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;ACLF;AACA;;GAEG;ADOH;EACE,YAAA;EACA,cAAA;ECLA,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EDOlB,YAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qDAAA;EACA,6CAAA;ACLF;ADOA;EACE;IACE,uBAAA;ECLF;EDOA;IACE,yBAAA;ECLF;AACF;ADQA;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,yCAAA;ACNF;ADQA;EACE,cAAA;EACA,qBAAA;ACNF;ADQA;EAEE,gBAAA;EACA,cAAA;EACA,iBAAA;ACPF;ADSA;EACE,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;ACPF;ADSA;EACE,qBAAA;EACA,cAAA;EACA,gBAAA;ACPF;ADSA;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,2DAAA;EACA,4BAAA;EACA,sBAAA;ACPF;ADSA;EACE,iBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,uBAAA;EACA,4DAAA;EACA,4BAAA;EACA,sBAAA;ACPF;ADSA;EACE,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;ACPF;ADSA;EACE,YAAA;ACPF;ADSA;EACE,YAAA;ACPF;ADSA;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,YAAA;EACA,WAAA;EACA,yEAAA;EACA,4BAAA;EACA,sBAAA;EACA,cAAA;ACPF;ADSA;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;ECPA,gEAAgE;EDShE,4BAAA;EACA,sBAAA;ACPF;ADSA;EACE,YAAA;ACPF;ADUA;EACE,aAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;ECRA,0EAA0E;EDU1E,4BAAA;EACA,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACRF;ADWA;EACE,kCAAA;EACA,WAAA;ACTF;ADYA;EACE,kCAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;ACVF;ADaA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;ECXA,kEAAkE;EDalE,4BAAA;ECXA,+BAA+B;EDa/B,sBAAA;EACA,aAAA;ACXF;ADcA;EACE,wCAAA;ACZF;ADeA;EACE,qBAAA;ACbF;ADeA;EACE,qBAAA;ACbF;ADgBA;EACE,kBAAA;ACdF;ADiBA;EACE,2BAAA;ECfA,qBAAqB;EDgBrB,kBAAA;ECdA,sBAAsB;EDiBtB,QAAA;EACA,2BAAA;ECfA,kBAAkB;EDkBlB,UAAA;EACA,gBAAA;EChBA,gCAAgC;EAChC,iBAAiB;EDkBjB,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EAEA,aAAA;ECjBA,oBAAoB;EDmBpB,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,yBAAA;EACA,WAAA;ACjBF;ADoBA;EACE,cAAA;AClBF;ADoBA;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EClBA,mBAAmB;EDqBnB,WAAA;EACA,gCAAA;ACnBF;ADsBA;EACE,WAAA;EACA,kBAAA;ECpBA,+BAA+B;EDuB/B,YAAA;ECrBA,sBAAsB;EDuBtB,SAAA;EACA,2BAAA;EACA,mCAAA;EACA,oCAAA;EAEA,8BAAA;EAEA,aAAA;ACvBF;ADyBA;;EAEE,cAAA;ACvBF;AACA,0BAA0B;AD0B1B;ECxBE,wBAAwB;AAC1B;AD4BA;EACE,2BAAA;EC1BA,qBAAqB;ED2BrB,kBAAA;ECzBA,sBAAsB;ED4BtB,QAAA;EACA,2BAAA;EC1BA,kBAAkB;ED6BlB,UAAA;EACA,gBAAA;EC3BA,gCAAgC;EAChC,iBAAiB;ED6BjB,YAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EAEA,aAAA;EC5BA,oBAAoB;ED8BpB,eAAA;EACA,gBAAA;EACA,kCAAA;EACA,yBAAA;EACA,WAAA;AC5BF;AD+BA;EACE,cAAA;AC7BF;AD+BA;EACE,YAAA;EACA,cAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;EACA,8BAAA;EACA,YAAA;AC7BF;ADgCA;EACE,WAAA;EACA,kBAAA;EC9BA,+BAA+B;EDgC/B,YAAA;EC9BA,sBAAsB;EDgCtB,SAAA;EACA,gCAAA;EAEA,kCAAA;EACA,mCAAA;EAEA,6BAAA;EAEA,aAAA;ACjCF;ADmCA;;EAEE,cAAA;ACjCF;ADoCA;EACE,8BAAA;EACA,YAAA;EAEA,iBAAA;EACA,eAAA;EACA,gBAAA;ACnCF;ADqCA;EACE,kBAAA;ECnCA,qBAAqB;EDqCrB,aAAA;ECnCA,iBAAiB;EACjB,iBAAiB;EDqCjB,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,gCAAA;EACA,UAAA;EACA,eAAA;ACnCF;ADsCA;EACE,kBAAA;ECpCA,qBAAqB;EDsCrB,aAAA;ECpCA,iBAAiB;EACjB,iBAAiB;EDsCjB,YAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,eAAA;ACpCF;ADsCA;EACE,kBAAA;ECpCA,qBAAqB;EDsCrB,aAAA;ECpCA,iBAAiB;EACjB,iBAAiB;EDsCjB,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,eAAA;ACpCF;ADsCA;EACE,qBAAA;EACA,YAAA;ACpCF;ADsCA;EACE,QAAA;ACpCF;AACA,mCAAmC","sourcesContent":[".devnagri_container {\n  width: 9rem;\n  max-height: 800px;\n  margin-bottom: 10px;\n  /* position: fixed;\n    bottom: 70px;\n    right: 18px; */\n  padding: 1px;\n  display: none;\n  z-index: 99999999999999;\n  border-radius: 6px;\n  display: flex, none;\n  justify-content: center;\n}\n\n.devnagri_outermostdivclass {\n  max-width: fit-content;\n}\n\n.devnagri_container > ul {\n  background-color: white;\n  border: 1px solid #e3e3e3;\n  border-radius: 6px;\n  padding: 6px;\n  width: 100%;\n  max-height: 800px;\n  margin-bottom: 0;\n}\n.devnagri_container > ul > li {\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  line-height: 35px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: 'Verdana', sans-serif;\n}\n\n.devnagri_container > ul > li:hover {\n  background: var(--hover-bg-color);\n}\n\n.devnagri_open_button {\n  border: 1px solid #e3e3e3;\n  border-radius: 8px;\n  margin-bottom: 10px;\n  position: relative;\n  outline: none;\n  /* bottom: 23px; */\n  /* right: 18px; */\n  height: 40px;\n  max-width: 393px;\n  z-index: 9999999999999;\n  /* background-color: #ffffff; */\n  background-color: var(--button-bg-color);\n}\n\n.devnagri_owner_button {\n  outline: none;\n  cursor: pointer;\n  height: 27px;\n  width: 27px;\n  margin: 5px;\n  margin-left: 7px;\n  /* background-image: url(https://i.ibb.co/7vDdcRk/Edit-01.png); */\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.devnagri_owner_cancel_button {\n  border: 0;\n  outline: none;\n  cursor: pointer;\n  height: 27px;\n  width: 27px;\n  margin: 5px 0;\n  margin-left: 5px;\n  margin-right: 4px;\n  z-index: 99999999999999;\n  /* background-image: url(https://i.ibb.co/wQfhYSN/Cross-01.png); */\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n}\n.devnagri_owner_send_button {\n  outline: none;\n  cursor: pointer;\n  height: 27px;\n  width: 27px;\n  margin: 5px 0;\n  margin-left: 4px;\n  margin-right: 5px;\n  z-index: 99999999999999;\n  /* background-image: url(https://i.ibb.co/M5YHpVz/Save-01.png); */\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.devnagri_border {\n  border: 2px solid rgb(255, 4, 4);\n}\n.Devnagri-ring {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n}\n/* .button {\n  background-color: white;\n} */\n.Devnagri-ring:after {\n  content: ' ';\n  display: block;\n  /* position: fixed; */\n  /* bottom: 65px; */\n  /* right: 165px; */\n  height: 40px;\n  width: 40px;\n  color: rgb(8, 45, 252);\n  z-index: 99999999999999;\n  border-radius: 50%;\n  border: 2px solid rgb(8, 45, 252);\n  border-color: rgb(8, 45, 252) transparent rgb(8, 45, 252) transparent;\n  animation: Devnagri-ring 1.5s linear infinite;\n}\n@keyframes Devnagri-ring {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.devnagri_dynamic_container {\n  position: fixed;\n  bottom: 15px;\n  right: 50px;\n  left: 50px;\n  top: 15px;\n  width: 600px;\n  max-height: 390px;\n  background-color: rgb(255, 255, 255);\n  border: 2px solid rgb(173, 172, 172);\n  border-radius: 5px;\n  flex-wrap: wrap;\n  margin: 10px auto;\n  padding: 0 15px;\n  overflow-y: scroll;\n  z-index: 99999999999999999999999999999999;\n}\n.devnagri_div_lable_input {\n  padding: 0 5px;\n  display: inline-block;\n}\n.devnagri_label {\n  font-size: larger;\n  font-weight: 600;\n  line-height: 2;\n  font-size: larger;\n}\n.devnagri_h1_eng {\n  padding-left: 5px;\n  display: inline-block;\n  line-height: 1;\n  font-weight: 600;\n  font-size: larger;\n}\n.devnagri_h1_def_lang {\n  display: inline-block;\n  line-height: 2;\n  font-size: large;\n}\n.devnagri_seo_submit {\n  margin-left: 225px;\n  margin-top: 3px;\n  outline: none;\n  cursor: pointer;\n  border: 0;\n  float: left;\n  height: 30px;\n  width: 30px;\n  z-index: 99999999999999;\n  background-image: url(https://i.ibb.co/M5YHpVz/Save-01.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.devnagri_seo_cancel {\n  margin-left: 10px;\n  margin-top: 3px;\n  float: left;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  height: 30px;\n  width: 30px;\n  z-index: 99999999999999;\n  background-image: url(https://i.ibb.co/wQfhYSN/Cross-01.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.devnagri_form-control {\n  padding: 1px;\n  font-family: Arial;\n  font-size: 16px;\n  font-weight: 500;\n  border: 1px solid #cccccc;\n  display: block;\n}\n.devnagri_seo_cancel:hover {\n  opacity: 0.8;\n}\n.devnagri_seo_submit:hover {\n  opacity: 0.8;\n}\n.devnagri_divForArrow {\n  padding-top: 15px;\n  margin-left: 15px;\n  margin-right: 20px;\n  display: inline-block;\n  height: 33px;\n  width: 49px;\n  background-image: url(https://www.svgrepo.com/show/24357/right-arrow.svg);\n  background-repeat: no-repeat;\n  background-size: cover;\n  line-height: 1;\n}\n.devnagri_seo {\n  outline: none;\n  cursor: pointer;\n  height: 27px;\n  width: 27px;\n  margin-top: 5px;\n  margin-right: 5px;\n  margin-left: 7px;\n  /* background-image: url(https://i.ibb.co/m418FWD/SEO-01.png); */\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.devnagri_seo:hover {\n  opacity: 0.9;\n}\n\n.devnagri_logo {\n  outline: none;\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  margin: 5px 0;\n  margin-left: 5px;\n  margin-right: 7px;\n  /* background-image: url(https://i.ibb.co/GF54nQh/Devnagri-Logo-01.png); */\n  background-repeat: no-repeat;\n  background-size: cover;\n  padding: 0px;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.devnagri_logo svg {\n  background: transparent !important;\n  width: 24px;\n}\n\n.devnagri_written_lang {\n  font-family: 'Verdana', sans-serif;\n  line-height: 40px;\n  cursor: pointer;\n  font-size: 14px;\n  margin: 0 !important;\n  color: white;\n}\n\n.devnagri_upArrow {\n  cursor: pointer;\n  margin: 12px 7px;\n  width: 16px;\n  height: 16px;\n  /* background-image: url(https://i.ibb.co/4tXB2Xw/up-arrow.png); */\n  background-repeat: no-repeat;\n  /* background-color: #ffffff; */\n  background-size: cover;\n  display: flex;\n}\n\n.devnagri_upArrow svg {\n  background-color: transparent !important;\n}\n\n.devnagri_upArrow svg rect {\n  fill: #fff !important;\n}\n.devnagri_upArrow svg path {\n  fill: #fff !important;\n}\n\n.Devnagri-tooltip-toggle {\n  position: relative;\n}\n\n.Devnagri-tooltip-toggle:before {\n  content: attr(data-tooltip); /* here's the magic */\n  position: absolute;\n\n  /* vertically center */\n  top: 50%;\n  transform: translateY(-50%);\n\n  /* move to right */\n  left: 100%;\n  margin-left: 0px; /* and add a small left margin */\n\n  /* basic styles */\n  width: 50px;\n  padding: 2px;\n  margin: 0px;\n  border-radius: 3px;\n  text-align: center;\n\n  display: none; /* hide by default */\n\n  font-size: 10px;\n  font-weight: 500;\n  font-family: 'Verdana', sans-serif;\n  background-color: #3184c0;\n  color: #fff;\n}\n\n.Devnagri-tooltip-toggle:hover:before {\n  display: block;\n}\n.Devnagri-tooltip-toggle:before {\n  top: initial;\n  right: initial;\n  left: initial;\n  margin: initial;\n\n  /* set new values */\n  bottom: 78%;\n  transform: translate(-23%, -50%);\n}\n\n.Devnagri-tooltip-toggle:after {\n  content: '';\n  position: absolute;\n\n  /* position tooltip correctly */\n  bottom: 105%;\n  /* vertically center */\n  left: 50%;\n  transform: translateX(-47%);\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n\n  border-top: 10px solid #3184c0;\n\n  display: none;\n}\n.Devnagri-tooltip-toggle:hover:before,\n.Devnagri-tooltip-toggle:hover:after {\n  display: block;\n}\n\n/* new for devngari logo */\n.Devnagri-tooltip-toggle-pencil {\n  /* position: relative; */\n\n}\n\n.Devnagri-tooltip-toggle-pencil:before {\n  content: attr(data-tooltip); /* here's the magic */\n  position: absolute;\n\n  /* vertically center */\n  top: 50%;\n  transform: translateY(-50%);\n\n  /* move to right */\n  left: 100%;\n  margin-left: 0px; /* and add a small left margin */\n\n  /* basic styles */\n  width: 120px;\n  padding: 4px;\n  margin: 0px;\n  border-radius: 3px;\n  text-align: center;\n\n  display: none; /* hide by default */\n\n  font-size: 10px;\n  font-weight: 500;\n  font-family: 'Verdana', sans-serif;\n  background-color: #3184c0;\n  color: #fff;\n}\n\n.Devnagri-tooltip-toggle-pencil:hover:before {\n  display: block;\n}\n.Devnagri-tooltip-toggle-pencil:before {\n  top: initial;\n  right: initial;\n  left: 0px;\n  margin: initial;\n  bottom: 94%;\n  transform: translate(0%, -69%);\n  border: none;\n}\n\n.Devnagri-tooltip-toggle-pencil:after {\n  content: '';\n  position: absolute;\n  /* position tooltip correctly */\n  bottom: 101%;\n  /* vertically center */\n  left: 17%;\n  transform: translate(-44%, -61%);\n\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n\n  border-top: 8px solid #3184c0;\n\n  display: none;\n}\n.Devnagri-tooltip-toggle-pencil:hover:before,\n.Devnagri-tooltip-toggle-pencil:hover:after {\n  display: block;\n}\n\n.devnagri_vl {\n  border-left: 1px solid #a0a0a0;\n  height: 27px;\n\n  margin-right: 6px;\n  margin-top: 5px;\n  margin-left: 5px;\n}\n.devnagri_uiErrorEditor {\n  border-radius: 5px;\n  /* position: fixed; */\n  outline: none;\n  /* bottom: 0px; */\n  /* right: 18px; */\n  height: 24px;\n  padding: 0px 12px;\n  max-width: 300px;\n  z-index: 9999999999999999999;\n  background-color: blanchedalmond;\n  color: red;\n  font-size: 12px;\n}\n\n.devnagri_unsavedChanges {\n  border-radius: 5px;\n  /* position: fixed; */\n  outline: none;\n  /* bottom: 0px; */\n  /* right: 18px; */\n  height: 24px;\n  padding: 0px 12px;\n  width: 190px;\n  z-index: 9999999999999;\n  background-color: #dcda0d;\n  font-size: 12px;\n}\n.devnagri_savedChanges {\n  border-radius: 5px;\n  /* position: fixed; */\n  outline: none;\n  /* bottom: 0px; */\n  /* right: 18px; */\n  height: 25px;\n  padding: 0px 4px;\n  max-width: 110px;\n  color: rgb(253 250 250);\n  z-index: 99999999999;\n  background-color: #08eebc;\n  font-size: 12px;\n}\n#devnagri_subdomain {\n  text-decoration: none;\n  color: black;\n}\nmain header {\n  top: 0px;\n}\n",".devnagri_container {\n  width: 9rem;\n  max-height: 800px;\n  margin-bottom: 10px;\n  /* position: fixed;\n    bottom: 70px;\n    right: 18px; */\n  padding: 1px;\n  display: none;\n  z-index: 99999999999999;\n  border-radius: 6px;\n  display: flex, none;\n  justify-content: center;\n}\n.devnagri_outermostdivclass {\n  max-width: fit-content;\n}\n.devnagri_container > ul {\n  background-color: white;\n  border: 1px solid #e3e3e3;\n  border-radius: 6px;\n  padding: 6px;\n  width: 100%;\n  max-height: 800px;\n  margin-bottom: 0;\n}\n.devnagri_container > ul > li {\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  line-height: 35px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: 'Verdana', sans-serif;\n}\n.devnagri_container > ul > li:hover {\n  background: var(--hover-bg-color);\n}\n.devnagri_open_button {\n  border: 1px solid #e3e3e3;\n  border-radius: 8px;\n  margin-bottom: 10px;\n  position: relative;\n  outline: none;\n  /* bottom: 23px; */\n  /* right: 18px; */\n  height: 40px;\n  max-width: 393px;\n  z-index: 9999999999999;\n  /* background-color: #ffffff; */\n  background-color: var(--button-bg-color);\n}\n.devnagri_owner_button {\n  outline: none;\n  cursor: pointer;\n  height: 27px;\n  width: 27px;\n  margin: 5px;\n  margin-left: 7px;\n  /* background-image: url(https://i.ibb.co/7vDdcRk/Edit-01.png); */\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.devnagri_owner_cancel_button {\n  border: 0;\n  outline: none;\n  cursor: pointer;\n  height: 27px;\n  width: 27px;\n  margin: 5px 0;\n  margin-left: 5px;\n  margin-right: 4px;\n  z-index: 99999999999999;\n  /* background-image: url(https://i.ibb.co/wQfhYSN/Cross-01.png); */\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n}\n.devnagri_owner_send_button {\n  outline: none;\n  cursor: pointer;\n  height: 27px;\n  width: 27px;\n  margin: 5px 0;\n  margin-left: 4px;\n  margin-right: 5px;\n  z-index: 99999999999999;\n  /* background-image: url(https://i.ibb.co/M5YHpVz/Save-01.png); */\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.devnagri_border {\n  border: 2px solid #ff0404;\n}\n.Devnagri-ring {\n  display: inline-block;\n  width: 40px;\n  height: 40px;\n}\n/* .button {\n  background-color: white;\n} */\n.Devnagri-ring:after {\n  content: ' ';\n  display: block;\n  /* position: fixed; */\n  /* bottom: 65px; */\n  /* right: 165px; */\n  height: 40px;\n  width: 40px;\n  color: #082dfc;\n  z-index: 99999999999999;\n  border-radius: 50%;\n  border: 2px solid #082dfc;\n  border-color: #082dfc transparent #082dfc transparent;\n  animation: Devnagri-ring 1.5s linear infinite;\n}\n@keyframes Devnagri-ring {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.devnagri_dynamic_container {\n  position: fixed;\n  bottom: 15px;\n  right: 50px;\n  left: 50px;\n  top: 15px;\n  width: 600px;\n  max-height: 390px;\n  background-color: #ffffff;\n  border: 2px solid #adacac;\n  border-radius: 5px;\n  flex-wrap: wrap;\n  margin: 10px auto;\n  padding: 0 15px;\n  overflow-y: scroll;\n  z-index: 99999999999999999999999999999999;\n}\n.devnagri_div_lable_input {\n  padding: 0 5px;\n  display: inline-block;\n}\n.devnagri_label {\n  font-weight: 600;\n  line-height: 2;\n  font-size: larger;\n}\n.devnagri_h1_eng {\n  padding-left: 5px;\n  display: inline-block;\n  line-height: 1;\n  font-weight: 600;\n  font-size: larger;\n}\n.devnagri_h1_def_lang {\n  display: inline-block;\n  line-height: 2;\n  font-size: large;\n}\n.devnagri_seo_submit {\n  margin-left: 225px;\n  margin-top: 3px;\n  outline: none;\n  cursor: pointer;\n  border: 0;\n  float: left;\n  height: 30px;\n  width: 30px;\n  z-index: 99999999999999;\n  background-image: url(https://i.ibb.co/M5YHpVz/Save-01.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.devnagri_seo_cancel {\n  margin-left: 10px;\n  margin-top: 3px;\n  float: left;\n  cursor: pointer;\n  outline: none;\n  border: 0;\n  height: 30px;\n  width: 30px;\n  z-index: 99999999999999;\n  background-image: url(https://i.ibb.co/wQfhYSN/Cross-01.png);\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.devnagri_form-control {\n  padding: 1px;\n  font-family: Arial;\n  font-size: 16px;\n  font-weight: 500;\n  border: 1px solid #cccccc;\n  display: block;\n}\n.devnagri_seo_cancel:hover {\n  opacity: 0.8;\n}\n.devnagri_seo_submit:hover {\n  opacity: 0.8;\n}\n.devnagri_divForArrow {\n  padding-top: 15px;\n  margin-left: 15px;\n  margin-right: 20px;\n  display: inline-block;\n  height: 33px;\n  width: 49px;\n  background-image: url(https://www.svgrepo.com/show/24357/right-arrow.svg);\n  background-repeat: no-repeat;\n  background-size: cover;\n  line-height: 1;\n}\n.devnagri_seo {\n  outline: none;\n  cursor: pointer;\n  height: 27px;\n  width: 27px;\n  margin-top: 5px;\n  margin-right: 5px;\n  margin-left: 7px;\n  /* background-image: url(https://i.ibb.co/m418FWD/SEO-01.png); */\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n.devnagri_seo:hover {\n  opacity: 0.9;\n}\n.devnagri_logo {\n  outline: none;\n  cursor: pointer;\n  width: 30px;\n  height: 30px;\n  margin: 5px 0;\n  margin-left: 5px;\n  margin-right: 7px;\n  /* background-image: url(https://i.ibb.co/GF54nQh/Devnagri-Logo-01.png); */\n  background-repeat: no-repeat;\n  background-size: cover;\n  padding: 0px;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.devnagri_logo svg {\n  background: transparent !important;\n  width: 24px;\n}\n.devnagri_written_lang {\n  font-family: 'Verdana', sans-serif;\n  line-height: 40px;\n  cursor: pointer;\n  font-size: 14px;\n  margin: 0 !important;\n  color: white;\n}\n.devnagri_upArrow {\n  cursor: pointer;\n  margin: 12px 7px;\n  width: 16px;\n  height: 16px;\n  /* background-image: url(https://i.ibb.co/4tXB2Xw/up-arrow.png); */\n  background-repeat: no-repeat;\n  /* background-color: #ffffff; */\n  background-size: cover;\n  display: flex;\n}\n.devnagri_upArrow svg {\n  background-color: transparent !important;\n}\n.devnagri_upArrow svg rect {\n  fill: #fff !important;\n}\n.devnagri_upArrow svg path {\n  fill: #fff !important;\n}\n.Devnagri-tooltip-toggle {\n  position: relative;\n}\n.Devnagri-tooltip-toggle:before {\n  content: attr(data-tooltip);\n  /* here's the magic */\n  position: absolute;\n  /* vertically center */\n  top: 50%;\n  transform: translateY(-50%);\n  /* move to right */\n  left: 100%;\n  margin-left: 0px;\n  /* and add a small left margin */\n  /* basic styles */\n  width: 50px;\n  padding: 2px;\n  margin: 0px;\n  border-radius: 3px;\n  text-align: center;\n  display: none;\n  /* hide by default */\n  font-size: 10px;\n  font-weight: 500;\n  font-family: 'Verdana', sans-serif;\n  background-color: #3184c0;\n  color: #fff;\n}\n.Devnagri-tooltip-toggle:hover:before {\n  display: block;\n}\n.Devnagri-tooltip-toggle:before {\n  top: initial;\n  right: initial;\n  left: initial;\n  margin: initial;\n  /* set new values */\n  bottom: 78%;\n  transform: translate(-23%, -50%);\n}\n.Devnagri-tooltip-toggle:after {\n  content: '';\n  position: absolute;\n  /* position tooltip correctly */\n  bottom: 105%;\n  /* vertically center */\n  left: 50%;\n  transform: translateX(-47%);\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  border-top: 10px solid #3184c0;\n  display: none;\n}\n.Devnagri-tooltip-toggle:hover:before,\n.Devnagri-tooltip-toggle:hover:after {\n  display: block;\n}\n/* new for devngari logo */\n.Devnagri-tooltip-toggle-pencil {\n  /* position: relative; */\n}\n.Devnagri-tooltip-toggle-pencil:before {\n  content: attr(data-tooltip);\n  /* here's the magic */\n  position: absolute;\n  /* vertically center */\n  top: 50%;\n  transform: translateY(-50%);\n  /* move to right */\n  left: 100%;\n  margin-left: 0px;\n  /* and add a small left margin */\n  /* basic styles */\n  width: 120px;\n  padding: 4px;\n  margin: 0px;\n  border-radius: 3px;\n  text-align: center;\n  display: none;\n  /* hide by default */\n  font-size: 10px;\n  font-weight: 500;\n  font-family: 'Verdana', sans-serif;\n  background-color: #3184c0;\n  color: #fff;\n}\n.Devnagri-tooltip-toggle-pencil:hover:before {\n  display: block;\n}\n.Devnagri-tooltip-toggle-pencil:before {\n  top: initial;\n  right: initial;\n  left: 0px;\n  margin: initial;\n  bottom: 94%;\n  transform: translate(0%, -69%);\n  border: none;\n}\n.Devnagri-tooltip-toggle-pencil:after {\n  content: '';\n  position: absolute;\n  /* position tooltip correctly */\n  bottom: 101%;\n  /* vertically center */\n  left: 17%;\n  transform: translate(-44%, -61%);\n  border-left: 8px solid transparent;\n  border-right: 8px solid transparent;\n  border-top: 8px solid #3184c0;\n  display: none;\n}\n.Devnagri-tooltip-toggle-pencil:hover:before,\n.Devnagri-tooltip-toggle-pencil:hover:after {\n  display: block;\n}\n.devnagri_vl {\n  border-left: 1px solid #a0a0a0;\n  height: 27px;\n  margin-right: 6px;\n  margin-top: 5px;\n  margin-left: 5px;\n}\n.devnagri_uiErrorEditor {\n  border-radius: 5px;\n  /* position: fixed; */\n  outline: none;\n  /* bottom: 0px; */\n  /* right: 18px; */\n  height: 24px;\n  padding: 0px 12px;\n  max-width: 300px;\n  z-index: 9999999999999999999;\n  background-color: blanchedalmond;\n  color: red;\n  font-size: 12px;\n}\n.devnagri_unsavedChanges {\n  border-radius: 5px;\n  /* position: fixed; */\n  outline: none;\n  /* bottom: 0px; */\n  /* right: 18px; */\n  height: 24px;\n  padding: 0px 12px;\n  width: 190px;\n  z-index: 9999999999999;\n  background-color: #dcda0d;\n  font-size: 12px;\n}\n.devnagri_savedChanges {\n  border-radius: 5px;\n  /* position: fixed; */\n  outline: none;\n  /* bottom: 0px; */\n  /* right: 18px; */\n  height: 25px;\n  padding: 0px 4px;\n  max-width: 110px;\n  color: #fdfafa;\n  z-index: 99999999999;\n  background-color: #08eebc;\n  font-size: 12px;\n}\n#devnagri_subdomain {\n  text-decoration: none;\n  color: black;\n}\nmain header {\n  top: 0px;\n}\n/*# sourceMappingURL=main.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
